import { Input, Modal, Select, Space, Typography } from 'antd'
import { useEffect, useState } from 'react'
import {
  SwitchToQuickBooksReason,
  getConfirmDetails,
  showTellUsMore,
  switchToQuickBooksReasons,
} from './switchToQuickBooksFeedbackModel'

export type Props = {
  isOpen: boolean
  onConfirm: (reason: SwitchToQuickBooksReason, details?: string) => void
  onCancel: () => void
  isConfirming?: boolean
  initialReason?: SwitchToQuickBooksReason
}

const SwitchToQuickBooksFeedbackModal = ({ isOpen, onConfirm, onCancel, isConfirming, initialReason }: Props) => {
  const [reason, setReason] = useState<SwitchToQuickBooksReason | null>(initialReason ?? null)
  const [details, setDetails] = useState('')

  useEffect(() => {
    setReason(initialReason ?? null)
    setDetails('')
  }, [isOpen])

  const handleConfirm = () => {
    if (reason === null) {
      return
    }
    onConfirm(reason, getConfirmDetails(reason, details))
  }

  return <Modal
    title="Switching Back to QuickBooks?"
    open={isOpen}
    onCancel={onCancel}
    okText="Switch to Quickbooks"
    onOk={handleConfirm}
    okButtonProps={{ disabled: reason === null || isConfirming, loading: isConfirming }}
    cancelButtonProps={{ disabled: isConfirming }}
  >
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Typography.Text type="secondary">Help us understand why so we can improve.</Typography.Text>
      <div>
        Reason for switching
        <br/>
        <Select
          placeholder="Select a reason"
          value={reason}
          onChange={(value) => setReason(value)}
          options={switchToQuickBooksReasons.map((r) => ({ value: r, label: r }))}
          style={{ width: '100%' }}
        />
      </div>
      {showTellUsMore(reason) && <div>
        Tell us more (optional)
        <br/>
        <Input.TextArea
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          rows={3}
          maxLength={1000}
        />
      </div>}
    </Space>
  </Modal>
}

export default SwitchToQuickBooksFeedbackModal
